import { Navigate, Outlet } from 'react-router-dom'
import { usePortalContext } from '../lib/portalContext'
import { RouteLoader } from './RouteLoader'

// Gate for the /org/* portal. A signed-in user who does not resolve to an
// org-admin is sent back to the root, where RootRedirect routes them to the
// creator portal instead.
export function RequireOrganization() {
  const { data, isLoading, error } = usePortalContext()
  if (isLoading) return <RouteLoader />
  // Unknown membership (5xx, network) is not "not an org admin" — throw to the
  // ErrorBoundary instead of bouncing through / into the creator portal.
  if (error) throw error
  if (data?.selected.kind !== 'organization') return <Navigate to="/" replace />
  return <Outlet />
}
